<template lang="pug">
i.fa(:class='customClasses', @mouseenter='mouseenter')
</template>
<script>
import modalsBus from '@/components/shared/ModalsBus'

import {mapGetters} from 'vuex'

export default {
  props: {
    editable: {
      type: Boolean,
      required: false,
      default: false
    },
    event: {
      type: Object,
      required: true
    },
    textualAnswer: {
      type: String,
      required: false
    },
    subject: {
      required: true
    }
  },
  data () {
    return {
      fixedSubject: null
    }
  },
  created () {
    this.fixSubject()
  },
  computed: {
    ...mapGetters('user', [
      'user'
    ]),
    customClasses () {
      if (this.fixedSubject === 'status') {
        return {
          'fa-check': this.event.status === 'CONFIRMED',
          green: this.event.status === 'CONFIRMED',
          'fa-times': this.event.status === 'REFUSED',
          red: this.event.status === 'REFUSED',
          'fa-question': this.event.status === 'WAITING'
        }
      }
      let classes = {
        green: this.isPresent(this.fixedSubject),
        red: this.isAbsent(this.fixedSubject),
        orange: this.isMaybe(this.fixedSubject)
      }
      if (this.fixedSubject === 'group') {
        classes['fa-group'] = true
      } else {
        classes['fa-user'] = true
      }
      return classes
    },
    answer () {
      let user = this.fixedSubject
      if (this.fixedSubject === 'status') {
        return this.event.status
      } else if (this.fixedSubject === 'group') {
        return this.event.groupAnswer
      } else if (this.fixedSubject === 'currentUser') {
        user = this.user
      }
      return this.event.answers[user.id || user.name] && this.event.answers[user.id || user.name].answer
    }
  },
  methods: {
    isPresent (user) {
      if (this.textualAnswer) {
        return this.textualAnswer === 'present'
      }
      if (user === 'group') {
        return this.event.groupAnswer === 'Yes'
      } else if (user === 'currentUser') {
        user = this.user
      }
      return typeof this.event.answers[user.id || user.name] !== 'undefined' &&
        this.event.answers[user.id || user.name].answer === 'Yes'
    },
    isAbsent (user) {
      if (this.textualAnswer) {
        return this.textualAnswer === 'absent'
      }
      if (user === 'group') {
        return this.event.groupAnswer === 'No'
      } else if (user === 'currentUser') {
        user = this.user
      }
      return typeof this.event.answers[user.id || user.name] !== 'undefined' &&
        this.event.answers[user.id || user.name].answer === 'No'
    },
    isMaybe (user) {
      if (this.textualAnswer) {
        return this.textualAnswer === 'maybe'
      }
      if (user === 'group') {
        return this.event.groupAnswer === 'Maybe'
      } else if (user === 'currentUser') {
        user = this.user
      }
      return typeof this.event.answers[user.id || user.name] !== 'undefined' &&
        this.event.answers[user.id || user.name].answer === 'Maybe'
    },
    isWithoutAnswer (user) {
      if (this.textualAnswer) {
        return this.textualAnswer === 'noanswer'
      }
      if (user === 'group') {
        return typeof this.event.groupAnswer === 'undefined' || this.event.groupAnswer === null || this.event.groupAnswer === false
      } else if (user === 'currentUser') {
        user = this.user
      }
      return typeof this.event.answers[user.id || user.name] === 'undefined' ||
        typeof this.event.answers[user.id || user.name].answer === 'undefined' ||
        this.event.answers[user.id || user.name].answer === null
    },
    mouseenter (e) {
      if (this.editable) { // && !e.shiftKey) {
        modalsBus.open(modalsBus.modals.EDIT_ANSWER, {
          subject: this.fixedSubject,
          currentAnswer: this.answer,
          event: this.event,
          element: this.$el,
          quick: e.altKey
        })
      }
    },
    fixSubject () {
      this.fixedSubject = this.subject
      if (this.subject === 'currentUser') {
        this.fixedSubject = this.user
      }
    }
  },
  watch: {
    subject () {
      this.fixSubject()
    }
  }
}
</script>



// WEBPACK FOOTER //
// Answer.vue?1cc35c2d